import { translations as en } from './en';
import { translations as zh } from './zh';

export const translations = {
  en,
  zh,
};

export type SupportedLanguage = 'en' | 'zh';
export type TranslationKeys = typeof en;
